/** 主应用律动页视觉参数快照，供键盘子应用灯光页虚拟键盘与实体下发对齐 */

export type RhythmVisualParamsSnapshot = {
  amplitudeScale: number;
  useCustomColor: boolean;
  rhythmHighlightColor: string;
  hfdV1ForegroundMode: number;
  hfdV1BackgroundMode: number;
  hfdV1BackgroundBrightness: number;
};

export const RHYTHM_VISUAL_PARAMS_SESSION_KEY =
  "music-management:musicRhythm:visualParamsSnapshot";

const DEFAULT_VISUAL: RhythmVisualParamsSnapshot = {
  amplitudeScale: 100,
  useCustomColor: false,
  rhythmHighlightColor: "#00E5FF",
  hfdV1ForegroundMode: 1,
  hfdV1BackgroundMode: 0,
  hfdV1BackgroundBrightness: 100,
};

export function readRhythmVisualParamsFromSession(): RhythmVisualParamsSnapshot {
  if (typeof window === "undefined") return { ...DEFAULT_VISUAL };
  try {
    const raw = window.sessionStorage.getItem(RHYTHM_VISUAL_PARAMS_SESSION_KEY);
    if (!raw) return { ...DEFAULT_VISUAL };
    const parsed = JSON.parse(raw) as Partial<RhythmVisualParamsSnapshot>;
    return {
      amplitudeScale:
        Number(parsed.amplitudeScale) || DEFAULT_VISUAL.amplitudeScale,
      useCustomColor: Boolean(parsed.useCustomColor),
      rhythmHighlightColor:
        typeof parsed.rhythmHighlightColor === "string"
          ? parsed.rhythmHighlightColor
          : DEFAULT_VISUAL.rhythmHighlightColor,
      hfdV1ForegroundMode:
        Number(parsed.hfdV1ForegroundMode) ||
        DEFAULT_VISUAL.hfdV1ForegroundMode,
      hfdV1BackgroundMode:
        Number(parsed.hfdV1BackgroundMode) ||
        DEFAULT_VISUAL.hfdV1BackgroundMode,
      hfdV1BackgroundBrightness: Number.isFinite(
        Number(parsed.hfdV1BackgroundBrightness)
      )
        ? Number(parsed.hfdV1BackgroundBrightness)
        : DEFAULT_VISUAL.hfdV1BackgroundBrightness,
    };
  } catch {
    return { ...DEFAULT_VISUAL };
  }
}

export function persistRhythmVisualParamsToSession(
  params: RhythmVisualParamsSnapshot
): void {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.setItem(
      RHYTHM_VISUAL_PARAMS_SESSION_KEY,
      JSON.stringify(params)
    );
  } catch {
    // ignore
  }
}
